import { Connection } from "@solana/web3.js";

// Environment Configuration
export const rpcUrl = import.meta.env.PROD
  ? import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_PRODUCTION
  : import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_DEVELOPMENT;

/**
 * Confirm transaction
 *
 * @param {string} txSignature
 * @returns {Promise<void>}
 */
export const confirmTransaction = async (txSignature: any) => {
  const connection = new Connection(rpcUrl);

  // Get latest blockhash first
  const latestBlockhash = await connection.getLatestBlockhash();

  // Confirm transaction with explicit options
  const confirmation = await connection.confirmTransaction(
    {
      signature: txSignature,
      blockhash: latestBlockhash.blockhash,
      lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
    },
    "confirmed",
  );
  console.log("Confirmation", confirmation);

  // Check if transaction was successful
  const tx = await connection.getTransaction(txSignature, {
    maxSupportedTransactionVersion: 0,
    commitment: "confirmed",
  });
  if (tx?.meta?.err) {
    throw new Error("Transaction failed");
  }

  console.log("Transaction confirmed");
};
